import React, { useCallback } from 'react';
import { Link } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import messages from './AdacFooter.messages';
import metadata from './AdacFooter.metadata.json5';
import styles from './AdacFooter.module.scss';

function AdacFooter() {
    const generateLinks = useCallback(() => {
        return (
            <div className={styles.footerMenuLinksContainer}>
                <ul className={styles.footerMenuLinks}>
                    <li className={styles.footerLink}>
                        <Link href={messages.privacyLink} target="_blank">{messages.privacyText}</Link>
                    </li>
                    <li className={styles.footerLink}>
                        <Link href={messages.cookiesLink} target="_blank">{messages.cookiesText}</Link>
                    </li>
                    <li className={styles.footerLink}>
                        <Link href={messages.imprintLink} target="_blank">{messages.imprintText}</Link>
                    </li>
                    <li className={styles.footerLink}>
                        <Link href={messages.contactLink} target="_blank">{messages.contactText}</Link>
                    </li>
                </ul>
            </div>
        );
    }, []);

    const resolvers = {
        resolveComponentMap: {
            generateLinks

        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={{}}
            {...resolvers}
            showHidden={false}
        />
    );
}

export default withRouter(AdacFooter);
